import Typography from '../../../../../../shared/library/Typography';
import { StyledBoltIcon, StyledListHeading } from './styles';

export interface ListHeadingProps {
  title: string;
}

export default function ListHeading(props: ListHeadingProps) {
  const { title } = props;

  return (
    <StyledListHeading>
      <StyledBoltIcon />
      <Typography variant="subtitle2" neutralColorIndex={700}>
        {title}
      </Typography>
    </StyledListHeading>
  );
}
